import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import CourseCardDashboard from "../components/CourseCardDashboard";
import { NameContext } from "../context/NameContext";
import UpdateUserProfileModal from "../components/UpdateUserProfileModal";
import PasswordChangeModal from "./PasswordChangeModal";
import PaperBG from "../kits/DesignKit/PaperBG";

import { useNavigate } from "react-router-dom"; // <-- RICHTIG importieren

const Dashboard = () => {
  const { userId, logout, token, mustChangePassword, setMustChangePassword } = useAuth();
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState("");
  const [firstName, setFirstName] = useState("");
  const { setName, setIsNameEntered } = useContext(NameContext);

  const navigate = useNavigate(); // <-- NICHT {useNavigate}, sondern const navigate = useNavigate()

  useEffect(() => {
    if (!userId) {
      navigate("/login"); // Sofort zurück zum Login wenn keine Auth!
      return;
    }

    const fetchCourses = async () => {
      try {
        const res = await fetch(
          `https://www.denisbitter.de/stage01/api/get_user_courses.php?userId=${userId}`
        );
        const data = await res.json();

        if (data.success && Array.isArray(data.data)) {
          const rawCourses = data.data;
          const normalizedCourses = rawCourses.map((c) => ({
            id: c.course_id,
            slug: c.course_slug,
            title: c.course_title,
            description: c.course_description,
            iconName: c.course_icon,
            category: c.course_category,
            startDate: c.course_startDate,
            customDate: c.registration_custom_date,
            pdfPath: c.registration_pdf_path,
            firstName: c.registrant_first_name,
            lastName: c.registrant_last_name,
            registrationDate: c.registration_date,
            registrationId: c.registration_id,
          }));

          setCourses(normalizedCourses);

          const name = normalizedCourses[0]?.firstName || "";
          if (name) {
            setName(name);
            setIsNameEntered(true);
          }
          setFirstName(name);
        } else {
          setError(data.message || "Keine Kurse gefunden.");
        }
      } catch (err) {
        console.error("❌ Fehler beim Laden:", err);
        setError("Fehler beim Laden der Kurse.");
      }
    };

    fetchCourses();
  }, [userId, setName, setIsNameEntered, navigate]); // <-- navigate als Dependency!

  return (
    <PaperBG>
      <>
        {mustChangePassword && (
          <PasswordChangeModal onClose={() => setMustChangePassword(false)} />
        )}
        <div className="min-h-screen justify-center">
          <div className="max-w-3xl mx-auto text-left px-6 py-12 font-mono">
            <h1 className="text-sm font-mono mb-1">
              Moin, {firstName ? firstName : `Benutzer #${userId}`}
              <h2 className="text-xs font-mono mb-4">Deine Trainings</h2>
            </h1>
            <div className="text-right mb-10">
              <UpdateUserProfileModal initialData={courses[0]} />
              {error && <p className="text-red-500">{error}</p>}
              <div className="justify-center py-10">
                {courses.length > 0 ? (
                  courses.map((course) => (
                    <CourseCardDashboard 
                      key={course.id} 
                      course={course} 
                      formattedDate={course.formattedDate}
                    />
                  ))
                ) : (
                  !error && <p>Keine Kurse verfügbar.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </PaperBG>
  );
};

export default Dashboard;
